import { render, staticRenderFns } from "./GptHubIntegration.vue?vue&type=template&id=56b5fa44"
import script from "./GptHubIntegration.vue?vue&type=script&lang=ts"
export * from "./GptHubIntegration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports